import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.9992 2.5C16.4093 2.5 11.1104 2.73162 7.79857 2.95034C4.54906 3.16495 1.93058 5.59452 1.62864 8.89477C1.60453 9.15838 1.58052 9.43449 1.55684 9.72329C1.34218 12.3409 3.43966 14.5 6.00338 14.5H41.9951C44.5588 14.5 46.6563 12.3408 46.4416 9.72329C46.4179 9.43449 46.3939 9.15837 46.3698 8.89477C46.0679 5.59451 43.4494 3.16496 40.1999 2.95035C36.888 2.73162 31.5892 2.5 23.9992 2.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.00338 17H41.9951C42.5101 17 43.0139 16.9436 43.5 16.8364V25.9998C43.5 31.9024 43.2938 36.1682 43.0814 38.9972C42.8338 42.2936 40.2937 44.8337 36.9974 45.0812C34.1684 45.2937 29.9026 45.4998 24 45.4998C18.0974 45.4998 13.8316 45.2937 11.0026 45.0812C7.70628 44.8337 5.16617 42.2936 4.91862 38.9972C4.70616 36.1682 4.5 31.9024 4.5 25.9998V16.8368C4.98561 16.9437 5.48889 17 6.00338 17ZM17.7481 28.9356C16.313 28.9014 15.0775 28.0195 15.0129 26.5855C15.0046 26.4024 15 26.2073 15 26C15 25.7926 15.0046 25.5976 15.0129 25.4145C15.0775 23.9805 16.313 23.0986 17.7481 23.0644C19.1419 23.0312 21.1968 23 24 23C26.8032 23 28.8581 23.0312 30.2519 23.0644C31.687 23.0986 32.9225 23.9805 32.9871 25.4145C32.9954 25.5976 33 25.7926 33 26C33 26.2073 32.9954 26.4024 32.9871 26.5855C32.9225 28.0195 31.687 28.9014 30.2519 28.9356C28.8581 28.9688 26.8032 29 24 29C21.1968 29 19.1419 28.9688 17.7481 28.9356Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }